<template>
<div class="chapter">
<div class="inner_page">
<h1>Contents</h1>
<ul>
<li><a href="#/Text/Flow_0_0001">Acknowledgments</a></li>
<li><a href="#/Text/Flow_0_0002">“I Have a Dream”</a></li>
<li><a href="#/Text/Flow_0_0003">Introduction: Lightning in a Bottle</a></li>
<li><span href="#/Text/Flow_0_0004" title="Link target outside of Sample">1. The Moment</span></li>
<li><span href="#/Text/Flow_0_0005" title="Link target outside of Sample">2. The March</span></li>
<li><span href="#/Text/Flow_0_0006" title="Link target outside of Sample">3. The Speech</span></li>
<li><span href="#/Text/Flow_0_0007" title="Link target outside of Sample">4. The Legacy</span></li>
<li><span href="#/Text/Flow_0_0008" title="Link target outside of Sample">Bibliography</span></li>
<li><span href="#/Text/Section0001" title="Link target outside of Sample">About the Author</span></li>
</ul>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?528b2ba7